<template>
	<div class="login-wrap">
		<el-form ref="form" :model="form" class="login-form" @submit.native.prevent="handleLogin">
			<h2>OA-中科合研</h2>
			<el-form-item>
				<el-input v-model="form.username" placeholder="用户名" prefix-icon="el-icon-user"></el-input>
			</el-form-item>
			<el-form-item>
				<el-input v-model="form.password" type="password" placeholder="密码" prefix-icon="el-icon-lock"
					@keyup.enter.native="handleLogin"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" style="width:100%" :loading="loading" @click="handleLogin">登 录</el-button>
			</el-form-item>
		</el-form>

		<!-- 备案信息 -->
		<div class="login-beian">
			<beian-footer theme="dark" />
		</div>
	</div>
</template>

<script>
	import BeianFooter from '@/components/BeianFooter.vue'

	export default {
		name: 'Login',
		components: {
			BeianFooter
		},
		data() {
			return {
				loading: false,
				form: {
					username: '',
					password: ''
				}
			}
		},
		created() {
			// 记住上次登录的用户名
			const lastUser = localStorage.getItem('lastUsername')
			if (lastUser) {
				this.form.username = lastUser
			}
		},
		methods: {
			handleLogin() {
				if (!this.form.username || !this.form.password) {
					this.$message.warning('请输入用户名和密码')
					return
				}
				this.loading = true
				this.$store.dispatch('Login', this.form).then(() => {
					// 记住登录成功的用户名
					localStorage.setItem('lastUsername', this.form.username)
					location.reload()
				}).catch(() => {
					this.loading = false
				})
			}
		}
	}
</script>

<style scoped>
	.login-wrap {
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		background: linear-gradient(135deg, #1a3a5c 0%, #2d6aa0 100%);
		position: relative;
	}

	.login-beian {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 18px;
		padding: 0 16px;
		text-align: center;
	}

	.login-form {
		width: 380px;
		padding: 40px 30px;
		background: #fff;
		border-radius: 6px;
		box-shadow: 0 4px 24px rgba(0, 0, 0, 0.3);
	}

	.login-form h2 {
		text-align: center;
		margin-bottom: 28px;
		color: #303133;
	}
</style>
